import React from 'react';
import { RiExpandDiagonalSLine, RiChatNewLine  } from "react-icons/ri";
import SidePanelAIChatBot from './AIChatBot/SidePanelAIChatBot';
import StickyToolbar from "../../partials/layout/StickyToolbarAIChatBot";
import SystemHelper from "../../shared/systemHelper";

class AIChatBot extends React.Component {
    constructor(props) {
        super(props);
        this.panelCloseBtnRef1 = React.createRef();
        this.sidePanelRef = React.createRef();
        this.state = {
            isPanel1Open: false,
            isPanelExpanded: false,
            newChatRequestId: 0
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.isPanel1Open !== this.state.isPanel1Open ||
            prevState.isPanelExpanded !== this.state.isPanelExpanded
        ) {
            this.updateBodySpacing();
        }
    }

    componentWillUnmount() {
const content = document.getElementById("fastdraft-content");

if (content) {
    content.style.paddingRight = "";
}
    }

    getPanelWidth = () => {
    if (!this.state.isPanel1Open) {
        return 0;
    }

    return this.state.isPanelExpanded ? '100vw' : '480px';
};

updateBodySpacing = () => {
    const content = document.getElementById("fastdraft-content");

    if (!content) {
        return;
    }

    if (!this.state.isPanel1Open) {
        content.style.paddingRight = "";
        return;
    }

    content.style.paddingRight = this.state.isPanelExpanded
        ? "80vw"
        : "480px";
};

    handleExpandToggle = (e) => {
        e.preventDefault();

        this.setState(prevState => ({
            isPanelExpanded: !prevState.isPanelExpanded
        }));
    };

    handleClose = (e) => {
        e.preventDefault();

        this.setState({
            isPanel1Open: false,
            isPanelExpanded: false
        });
    };

handleNewChat = (e) => {
    e.preventDefault();

    this.setState(prevState => ({
        newChatRequestId: prevState.newChatRequestId + 1,
        isPanel1Open: true
    }));
};

    handleToggle = (panelNum, isOpen) => {
        this.setState({ isPanel1Open: isOpen });

        if (isOpen) {
            SystemHelper.hubspotUpdateEvent("AI_CHATBOT_PANEL_OPEN");
        }
    };

    render() {
        const isPanelOnScreen = this.state.isPanel1Open;
        const panelWidth = this.getPanelWidth();

        const panelStyle = {
            position: 'fixed',
            top: 0,
            right: isPanelOnScreen ? 0 : '-480px',
            width: panelWidth || '480px',
            height: '100vh',
            backgroundColor: '#fff',
            borderLeft: '1px solid #ddd',
            zIndex: 1000,
            overflow: 'hidden',
            transition: 'right 0.25s ease, width 0.25s ease',
            boxSizing: 'border-box',
            paddingTop: '40px',
            paddingRight: '14px',
            paddingLeft: '14px',
        };

        const actionButtonBaseStyle = {
            position: 'absolute',
            top: '20px',
            width: '36px',
            height: '36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#6c757d',
            textDecoration: 'none',
            zIndex: 1001,
            backgroundColor: '#fff',
            borderRadius: '4px',
        };

        return (
            <>
                <StickyToolbar
                    onToggle={this.handleToggle}
                    panelCloseBtnRef1={this.panelCloseBtnRef1}
                />

                <div
                    id="kt_quick_panel_4"
                    className="fd-ai-chatbot-sidebar"
                    style={panelStyle}
                >

                    <a
                        href="#"
                        id="kt_quick_panel_new_chat_btn_4"
                        onClick={this.handleNewChat}
                        style={{
                            ...actionButtonBaseStyle,
                            right: '124px',
                            fontSize: '24px',
                            marginTop: '4px'
                        }}
                    >
                        <RiChatNewLine />
                    </a>

                    <a
                        href="#"
                        id="kt_quick_panel_expand_btn_4"
                        onClick={this.handleExpandToggle}
                        style={{
                            ...actionButtonBaseStyle,
                            right: '76px',
                            fontSize: '28px',
                            marginTop: '4px'
                        }}
                    >
                        <RiExpandDiagonalSLine />
                    </a>

                    <a
                        href="#"
                        id="kt_quick_panel_close_btn_4"
                        onClick={this.handleClose}
                        style={{
                            ...actionButtonBaseStyle,
                            right: '28px',
                            fontSize: '18px',
                            marginTop: '5px'
                        }}
                    >
                        <i className="flaticon2-delete" />
                    </a>

                    <SidePanelAIChatBot
                        newChatRequestId={this.state.newChatRequestId}
                        isOpen={this.state.isPanel1Open}
                        panelCloseBtnRef={this.panelCloseBtnRef1}
                    />
                </div>
            </>
        );
    }
}

export default AIChatBot;